import React, { useRef } from 'react'

import {
  Grid, Dialog,
  DialogTitle as MuiDialogTitle, Typography,
  IconButton, DialogContent as MuiDialogContent, Paper,
  Table, TableHead,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'
import { Close as CloseIcon } from '@material-ui/icons'

import { withStyles } from '@material-ui/core/styles'

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

const SupervisorUserList = ({ supervisor, actionType, userNames, startDate = 0, endDate = 0, toggleModal, open, classes, navigateToUser }) => {
  const componentRef = useRef()

  const modalToggle = () => {
    toggleModal()
  }

  const formatAction = (type) => {
    switch (type) {
      case 'problem_captures':
        return 'Problem Captures'
      case 'not_a_problem_captures':
        return 'Not A Problem Captures'
      case 'held_captures':
        return 'Held Captures'
      case 'resolved_captures':
        return 'Resolved Captures'
      case 'quarantined_captures':
        return 'Quarantined Captures'
      case 'viewed_captures':
        return 'Viewed Captures'
      case 'shared_captures':
        return 'Shared Captures'
      case 'flagged_captures':
        return 'Flagged Captures'
      case 'capture_comments':
        return 'Capture Comments'
      default:
        return ''
    }
  }

  return (
    <>
      <Dialog open={open} onClose={modalToggle} className='filterModal' fullWidth maxWidth='sm'>
        <MuiDialogTitle disableTypography>
          <Grid item container direction='row' justify='space-between'>
            <Typography
              variant='h4'
              color='primary'
              classes={{ colorPrimary: classes.greenText }}
              className='font-weight-bold'
            >
              User List for {supervisor},
            </Typography>

            <IconButton aria-label='close' className={classes.closeButton} onClick={modalToggle}>
              <CloseIcon />
            </IconButton>
          </Grid>

          <Grid item container direction='row' justify='flex-start'>
            <Typography
              variant='h4'
              color='primary'
              classes={{ colorPrimary: classes.greenText }}
              className='font-weight-bold'
            >
              {formatAction(actionType)}
            </Typography>
          </Grid>

          <Grid item container direction='row' justify='flex-start' style={{ marginTop: '1rem' }}>
            <Typography>
              Captures may not be viewable for periods greater than 3 months ago.
            </Typography>
          </Grid>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <Grid container justify='center' direction='row' className='mt-3'>
            <Grid container direction='column' justify='center'>
              <Grid container direction='row'>
                <Grid container item direction='column' justify='flex-end' xs={12} className={classes.tableContainer}>
                  <Paper elevation={2} className={classes.tablePaper}>
                    <Grid
                      container
                      direction='column'
                      justify='center'
                      className='px-3 w-100 py-3 mx-auto my-auto'
                      spacing={2}
                    >
                      {
                        userNames.length > 0
                          ? (
                            <TableContainer>
                              <Table className={classes.table} size='small' aria-label='users-table'>
                                <TableHead>
                                  <TableRow>
                                    <TableCell className={`${classes.tableHeadText} unselectable`}>Users</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {userNames.map((user, index) => (
                                    <StyledTableRow key={index}>
                                      <TableCell
                                        align='left'
                                        className={classes.tableText}
                                        // style={{ cursor: 'pointer' }}
                                        // onClick={(e) => { e.preventDefault(); navigateToUser(user.userName) }}
                                      >
                                        {user.userName}
                                      </TableCell>
                                    </StyledTableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Grid item container direction='row' justify='center' alignItems='center'>
                              {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                              <Paper
                                className='mx-auto'
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: '10vh',
                                  height: '20rem',
                                  width: '30rem',
                                  padding: '1.5rem',
                                  backgroundColor: '#F5F5F5'
                                }}
                              >
                                <Grid item container direction='column' xs={12}>
                                  <Grid item container direction='row' justify='center'>
                                    <AnnouncementIcon
                                      style={{
                                        fontSize: '4rem',
                                        color: 'grey',
                                        marginBottom: '1rem'
                                      }}
                                    />
                                  </Grid>
                                  <Grid item container direction='row' justify='center'>
                                    <Typography
                                      style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                    >
                                      No Users Found
                                    </Typography>
                                  </Grid>
                                  <Grid item container direction='row' justify='center'>
                                    <Typography>There are currently no users associated with this supervisor/action during the given time frame. Please try again.</Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            </Grid>
                          )
                      }
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          <Grid item container direction='column' ref={componentRef} />
        </MuiDialogContent>
      </Dialog>
    </>
  )
}

export default SupervisorUserList
